var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBigLeaf = function SvgBigLeaf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350.74,
    height: 598.74,
    viewBox: "0 0 350.74 598.74",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BigLeaf",
    transform: "translate(-746 -3076.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M1130.741,516.221c0,132.074-78.516,178.189-175.37,178.189S780,648.294,780,516.221,955.37,216.127,955.37,216.127,1130.741,384.146,1130.741,516.221Z",
    transform: "translate(-34 2860.49)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M814.733,621.7l1.8-110.535,74.747-136.746L816.81,493.823l.807-49.7,51.516-98.935-51.3,85.782h0l1.452-89.389,55.165-78.765-54.937,64.708.907-163.907-5.7,216.983.469-8.951L759.1,285.8l55.187,103.031-5.226,99.832-.155-2.65-64.657-90.343,64.46,99.7-.654,12.485-.117.187.054,1.025L794.734,762.357h17.714l2.125-130.825,64.3-99.46Z",
    transform: "translate(100.249 2913)",
    fill: "#3f3d56"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBigLeaf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BigLeaf.e5803c82.svg";
export { ForwardRef as ReactComponent };